export enum ProcuraconContextType {
	RFX_PRE_SUBMISSION = 1,
	// Values 2-4 are allocated: FILE_DOWNLOAD_RFX_PDF_SUMMARY=2, FILE_DOWNLOAD_RFX_PDF_RESPONSE=3, FILE_DOWNLOAD_CLARIFICATION_EXPORT=4
	CONVERSATION_CLARIFICATION = 5,
}
